export const vehiclePageStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: '20px',
    marginBottom: '20px',
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: { xs: '100%', sm: 'auto' },
    gap: '20px',
  },
  fileUploadInput: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  },
  contentBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: '20px', sm: '30px' },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: { xs: '100%', sm: 'calc(33.33%)' },
    gap: '20px',
  },
  card: {
    borderRadius: '10px',
    padding: '15px 20px',
    border: '1px solid #ccc',
  },
  deleted: {
    'cursor': 'inherit',
    '&:hover': null,
    'background': 'rgba(165, 42, 42, 0.1)',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    textTransform: 'uppercase',
    marginBottom: '10px',
    fontFamily: 'Saira Extra Condensed',
  },
  photo: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: { xs: '250px', sm: '350px' },
    margin: '10px 0 20px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  picturesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: { xs: 'repeat(5, 1fr)', sm: 'repeat(7, 1fr)' },
    gap: '10px',
    width: '100%',
    height: { xs: '500px', sm: '700px' },
    margin: '10px 0 20px',
  },
  pictureMainTile: {
    gridColumn: 'span 3',
    gridRow: 'span 3',
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    borderRadius: '10px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pictureImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  pictureGridItem: {
    position: 'relative',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  pictureGridItemSelected: {
    outline: '3px solid #000',
    outlineOffset: '-3px',
  },
  pictureCheckbox: {
    'position': 'absolute',
    'top': '8px',
    'left': '8px',
    'zIndex': 2,
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'cursor': 'pointer',
    'opacity': 0,
    'transition': 'opacity 0.2s, transform 0.2s',
    'filter': 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3))',
    '&:hover': {
      transform: 'scale(1.15)',
    },
  },
  pictureCheckboxVisible: {
    opacity: 1,
  },
  pictureGridItemHoverable: {
    '&:hover .picture-checkbox': {
      opacity: 1,
    },
  },
  picturesFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  detailBox: {
    display: 'flex',
    marginBottom: '10px',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '20px',
  },
  detailTitle: {
    textTransform: 'uppercase',
    color: '#666',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto Condensed',
  },
  detailTextField: {
    width: '60%',
  },
  detailTextFieldFullWidth: {
    width: '100%',
  },
  detailTextFieldInput: {
    fontWeight: '500',
    fontSize: '1.1rem',
  },
  detailValue: {
    fontWeight: '500',
    fontSize: '1.1rem',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  },
  detailsSeparator: {
    height: '1px',
    backgroundColor: '#ccc',
    margin: '30px 10px 20px',
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '60%',
    textDecoration: 'none',
  },
};
